module.exports = __webpack_public_path__ + "static/media/list-of-invoice-white.c6a0877a.svg";